<template>
    <div class="page pay">
        <div class="order-info">
            <div class="session-info">
                <div class="order-item-img">
                    <img class="img" :src="detail.pic" />
                </div>
                <div class="order-item-content">
                    <div class="film-name">{{ detail.filmName }}</div>
                    <div class="time">
                        {{ detail.showDateOfChinese }} {{ detail.movieInformation }}
                    </div>
                    <div class="cinema-name">{{ detail.cinemaName }}</div>
                    <div class="hall-name">{{ detail.hallName }}</div>
                    <div class="seat-list">
                        <div
                            class="seat-item"
                            v-if="detail.seats"
                            v-for="(item, index) in detail.seats"
                            :key="index"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="tip-list" @click="showTip">
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持退票</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持改签</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-voice-red.png" />
                    <span>退改签须知</span>
                </div>
            </div>
        </div>
        <!-- <div class="model seat">
            <div class="line">
                <div class="line-title">座位</div>
                <div class="line-value secondary">
                    {{
                        detail.seats &&
                            detail.seats
                                .map(v => {
                                    return v.name;
                                })
                                .join(';')
                    }}
                </div>
            </div>
            <div class="accept-adjust-box">
                <div class="accept-adjust-title">无座时同意调座</div>
                <div
                    class="status"
                    @click="switchAcceptAdjust"
                    :class="{ 'accept-adjust': acceptAdjust }"
                ></div>
                <div class="accept-adjust-tip">
                    特惠票为低价抢购票，非下单实时锁座，您所选的座位若未购买成功，系统会为您自动匹配相邻的最佳观影位置出单。
                </div>
            </div>
            <div class="line">
                <div class="line-title">座位备选</div>
                <div class="line-value secondary">{{acceptAdjust ? "同意调座" : "不同意调座"}}</div>
            </div>
        </div> -->

        <div class="ticket-type-box" v-if="isShowSwitchDrawMode">
            <!-- <div class="title">购票方式</div> -->
            <div
                class="ticket-type-item"
                v-if="
                    $store.state.common.config.enableDiscount &&
                    !$store.state.common.config.enableAuction
                "
                :class="{ 'no-select': !status.preferential }"
                @click="clickChoose(0, status.preferential)"
            >
                <img
                    class="status-img"
                    :src="
                        require(chooseIndex == 0
                            ? '@/assets/icons/icon-choose.png'
                            : '@/assets/icons/icon-unchoose.png')
                    "
                />
                <div class="line">
                    <div class="name">特惠购票</div>
                    <div class="price">
                        <span class="text">¥{{ qzPrice || '--.--' }}</span>
                        <!-- <span class="company">/张</span> -->
                    </div>
                </div>
                <div class="line">
                    <div class="characteristic">提前订票</div>
                    <div class="characteristic">更加优惠</div>
                    <div class="characteristic">出票成功率95%</div>
                </div>
                <!-- <div class="tip-51">
                    51档热映期间，出票时间可能延长至60分钟出票，请耐心等待。
                </div> -->
                <div class="tip" :class="{ open: moreShow.preferential }">
                    <div class="line">
                        优惠大但耗时，适合
                        <span class="text">时间充裕</span>
                        提前购票用户
                    </div>
                    <div class="line">
                        平均出票时间20分钟，
                        <span class="text">排队中</span>
                        可随时取消
                    </div>
                    <div class="line">
                        出单中和已出票的订单
                        <span class="text">不可改签、退款</span>
                        ，未出票原路退回
                    </div>
                    <div
                        class="more-show"
                        @click.stop="moreShow.preferential = !moreShow.preferential"
                    ></div>
                </div>
            </div>
            <div
                class="ticket-type-item"
                v-if="$store.state.common.config.enableFastDrawMode"
                :class="{ 'no-select': !status.directPurchase }"
                @click="clickChoose(1, status.directPurchase)"
            >
                <img
                    class="status-img"
                    :src="
                        require(chooseIndex == 1
                            ? '@/assets/icons/icon-choose.png'
                            : '@/assets/icons/icon-unchoose.png')
                    "
                />
                <div class="line">
                    <div class="name">极速出票</div>
                    <div class="price">
                        <span class="text">¥{{ qmmPrice }}</span>
                        <!-- <span class="company">/张</span> -->
                    </div>
                </div>
                <div class="line">
                    <div class="characteristic">实时出票</div>
                    <div class="characteristic">临场可买</div>
                    <div class="characteristic">{{ fastDrawTime }}分钟未出退款</div>
                </div>
                <div class="tip" :class="{ open: moreShow.directPurchase }">
                    <div class="line">适合着急、临场用户</div>
                    <div class="line">实时锁座，方便快捷，折扣优惠</div>
                    <div class="line">
                        出单中和已出票的订单
                        <span class="text">不可改签、退款</span>
                        ，未出单
                        <span class="text">{{ fastDrawTime }}分钟退回</span>
                    </div>
                    <div
                        class="more-show"
                        @click.stop="moreShow.directPurchase = !moreShow.directPurchase"
                    ></div>
                </div>
            </div>
            <div
                class="ticket-type-item"
                v-if="$store.state.common.config.enableAuction"
                :class="{ 'no-select': !status.biddingPurchase }"
                @click="clickChoose(2, status.biddingPurchase)"
            >
                <img
                    class="status-img"
                    :src="
                        require(chooseIndex == 2
                            ? '@/assets/icons/icon-choose.png'
                            : '@/assets/icons/icon-unchoose.png')
                    "
                />
                <div class="line">
                    <div class="name doubt" @click.stop="doubt">询价比价购票</div>
                </div>
                <div class="tip" :class="{ open: moreShow.biddingPurchase }">
                    <div class="line">自动全网比价查询底价，底价满意再付款</div>
                    <!-- <div
                        class="more-show"
                        @click.stop="moreShow.biddingPurchase = !moreShow.biddingPurchase"
                    ></div> -->
                </div>
            </div>
        </div>
        <div class="model">
            <div class="line coupon">
                <div class="line-title">优惠券</div>
                <div class="coupon-info" @click="toSelectCoupon">
                    <div class="no-coupon" v-if="!detail.cardDiscountAmount">
                        {{ hasUseCoupon ? '请选择优惠券' : '暂无优惠券' }}
                    </div>
                    <div class="has-coupon" v-else>-{{ detail.cardDiscountAmount }}元</div>
                </div>
                <div class="icon-right"></div>
            </div>
            <div class="line price-box">
                <div class="line-title">
                    <div class="original-price" :class="{ 'line-through': (saveAmount || 0) > 0 }">
                        原价¥{{ totalMarketPrice }}
                    </div>
                    <div class="save-amount" v-if="(saveAmount || 0) > 0">
                        立省¥{{ saveAmount || 0 }}
                    </div>
                </div>
                <div class="line-value">
                    <div class="subtotal">共{{ detail.seatsCount }}张,票价合计:</div>
                    <div class="amount">¥{{ detail.totalPrice }}</div>
                </div>
            </div>
            <div class="line mobile">
                <div class="line-title">手机号</div>
                <div class="line-value">
                    <input
                        class="input"
                        maxlength="11"
                        type="number"
                        placeholder="必填"
                        v-model="userMobile"
                    />
                </div>
            </div>
            <div class="mobile-tip">接收出票短信提醒</div>
        </div>
        <div class="model">
            <div class="line notice">
                <div class="line-title bold">购票服务协议须知</div>
                <div class="line-value secondary" @click="checkRead">
                    <img
                        class="section-img"
                        :src="
                            require(payAgree
                                ? '@/assets/icons/icon-choose.32.png'
                                : '@/assets/icons/icon-unchoose.32.png')
                        "
                    />
                    <div class="text">{{ payAgree ? '已读' : '未读' }}</div>
                </div>
            </div>
            <div class="section-content" v-if="!isShowSwitchDrawMode && status.directPurchase">
                <div>
                    <span>
                        1.请确认场次和时间无误，购买成功后将
                        <span class="keynote">不予退换</span>
                        。
                    </span>
                </div>
                <div>
                    <span>
                        2.出票时间为0-16分钟，由于系统波动，场次调整等因素，存在出票失败的情况，出单失败后会在20分钟内原路退回，到账时间以付款平台规则为准。
                    </span>
                </div>
                <div>
                    <span>3.出票成功后请在我的订单中查看取票码，到对应</span>
                    <span class="keynote">影院自助机取票和影院前台</span>
                    <span>取票。</span>
                </div>
                <div>
                    <span>4.如遇问题请尽快联系下单页面客服咨询解决（9:00-23:00）。</span>
                </div>
            </div>
            <div class="section-content" v-else>
                <div>
                    <span>1.订单状态为排队中时可自行退款，出单中和已出票的订单</span>
                    <span class="keynote">不可取消！！！不可改签！！！</span>
                    <span>请确认后购买。</span>
                </div>
                <template v-if="$store.getters.getExposeMethod.hideTicketMethod">
                    <div>
                        <span>2.出票成功后请在我的订单中查看取票码，到对应</span>
                        <span class="keynote">影院自助机取票和影院前台</span>
                        <span>取票。</span>
                    </div>
                    <div>
                        <span v-if="!$store.getters.getExposeMethod.customerServiceMobileTip">
                            3.如遇问题请尽快联系页面客服咨询解决。
                        </span>
                        <span v-else>
                            3.如遇问题请尽快联系通联支付客服电话
                            <a href="tel:95193">95193</a>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <div>
                        <span>
                            2.出票是由平台入驻的商家提供影票代购服务，若出票失败，将会在两小时内自动退款。
                        </span>
                        <span class="keynote">夜间22：00～早9：00，不在两小时自动退款范围内</span>
                        <span>。夜间未出票订单最迟将在次日11：00退回。</span>
                    </div>
                    <div>
                        <span>
                            3.出票成功后请在我的订单中查看取票码，到对应影院自助取票机或者前台报取票码取票。
                        </span>
                        <span class="keynote">影院自助机取票和影院前台</span>
                        <span>取票。</span>
                    </div>
                    <div>
                        <span v-if="!$store.getters.getExposeMethod.customerServiceMobileTip">
                            4.如遇问题请尽快联系页面客服咨询解决。
                        </span>
                        <span v-else>
                            4.如遇问题请尽快联系通联支付客服电话
                            <a href="tel:95193">95193</a>
                        </span>
                    </div>
                </template>
            </div>
        </div>
        <div class="popup" v-if="showPopupStatus" @click="hideTip">
            <div class="tip-message iphone-x-adaptation" @click.stop="">
                <div class="title">退改签须知</div>
                <div class="content">
                    <p class="bold">关于退票：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持退票。
                    </p>
                    <p class="bold">关于改签：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持改签。
                    </p>
                </div>
                <div class="iphone-x-adaptation-padding iphone-x-adaptation"></div>
                <img class="close" src="~@/assets/icons/icon-close.png" @click="hideTip" />
            </div>
        </div>
        <div class="dialog" v-if="showAgreementStatus" @click="hideDialog">
            <div class="dialog-agreement" @click.stop="">
                <div class="title">购票服务协议须知</div>
                <div class="content">
                    <p class="no-1">
                        购票成功后
                        <span class="keynote">不支持退款，不支持改签！</span>
                    </p>
                    <p class="no-2">
                        点击同意本协议之前，请务必认真阅读、完全理解购票须知中全部条款。如点击同意后即代表您理解并接受协议的全部内容。
                    </p>
                    <p class="no-3">
                        如用户不同意接受本协议的任何条款，或无法理解本协议相关条款含义的，请不要进行后续操作（包括但不限于点击确认或继续使用平台服务等）。
                    </p>
                    <div class="line-agree" :class="{ ok: payAgree }" @click="payAgree = !payAgree">
                        <div class="value">我已阅读并同意以上协议</div>
                    </div>
                    <div
                        class="btn btn-agree"
                        :class="{ ok: payAgree }"
                        @click="payAgree && submit()"
                    >
                        继续购票
                    </div>
                    <div class="btn btn-no" @click="hideDialog">暂不购票</div>
                </div>
            </div>
        </div>
        <div class="footer-occupy iphone-x-adaptation"></div>
        <div class="footer iphone-x-adaptation">
            <div class="box">
                <div>
                    <div v-if="chooseIndex == 2">
                        <span>等待官方竞价：</span>
                        <span class="money">¥{{ biddingPredictPrice }}</span>
                    </div>
                    <div v-else>
                        <span>实际付款：</span>
                        <span class="money">¥{{ detail.totalPrice }}</span>
                    </div>
                    <div class="flex filme-another" v-if="detail.platformShowOptions">
                        <div
                            class="filme-commission"
                            v-for="(item, index) in detail.platformShowOptions"
                            :key="index"
                        >
                            <span>
                                {{ item.key }}
                                <span class="filme-commission-num">{{ item.value }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="btn" @click="showAgreementStatus = true">
                    <span v-if="chooseIndex == 2">提交订单</span>
                    <span v-else>
                        {{
                            $store.getters.getExposeMethod.expandName == 'FuDuDu'
                                ? '积分付款'
                                : '立即付款'
                        }}
                    </span>
                </div>
            </div>
        </div>
        <div
            class="accept-adjust-dialog"
            v-if="acceptAdjustDialogStatus"
            @click="acceptAdjustDialogStatus = false"
        >
            <div class="content" @click.stop="">
                <div class="header"></div>
                <div class="message">
                    <p>若您所选座位被他人占座时</p>
                    <p style="color: rgba(217, 2, 9, 1)">系统自动匹配剩余座位最佳观影区</p>
                </div>
                <div class="btn-list">
                    <div class="btn-item" @click="setAcceptAdjustStatus(false)">
                        <p>不调座</p>
                        <p>占座失败自动退款</p>
                    </div>
                    <div class="btn-item agree" @click="setAcceptAdjustStatus(true)">
                        <p>同意调座</p>
                        <p>多张票保证连座</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    GET_ORDER_INFO,
    UPDATE_ORDER_USER_MOBILE,
    GET_ORDER_INFO_FOR_ORDER_NO,
    SUBMIT_0_ORDER,
    GET_AVAILABLE_COUPON_LIST,
    GET_QMM_PRICE,
    UPDATE_ORDER_ACCEPT_ADJUST,
    UPDATE_ORDER_DRAW_MODE,
    SUBMIT_BID_ORDER,
} from 'api';
import { PAGE_COUPON_SELECT, PAGE_ORDER_INFO, PAGE_ORDER_BID } from 'page';
import moment from 'moment';
import pay from 'pay';
import number from '@/lib/number';
export default {
    data() {
        return {
            id: 0,
            orderNo: '',

            chooseIndex: -1,
            status: {
                preferential: !true,
                directPurchase: true,
                biddingPurchase: !true,
            },
            qzPrice: '--.--',
            qmmPrice: '--.--',

            moreShow: {
                preferential: false,
                directPurchase: false,
                biddingPurchase: false,
            },

            detail: {},
            message: '',
            payAgree: false,
            userMobile: '',
            showPopupStatus: false,
            showAgreementStatus: false,
            agreementBtnStatus: false,
            hasUseCoupon: false,
            acceptAdjust: false,
            acceptAdjustDialogStatus: false,

            // 原价总价值
            totalMarketPrice: 0,
            totalPrice: '--.--',
            saveAmount: 0,
        };
    },
    computed: {
        isShowSwitchDrawMode() {
            // 判断 快速 、 折扣 和 竞价 模式中是否有两个以上开启
            return (
                this.$store.state.common.config.enableAuction +
                    this.$store.state.common.config.enableFastDrawMode +
                    this.$store.state.common.config.enableDiscount >
                1
            );
        },
        fastDrawTime() {
            let _fastDrawTime = 16;
            if (this.$store.state.common.config.fastDrawModeVersion == 1) {
                _fastDrawTime = 16;
            } else if (this.$store.state.common.config.fastDrawModeVersion == 2) {
                _fastDrawTime = 30;
            }
            return _fastDrawTime;
        },
        biddingPredictPrice() {
            let minPrice = 0;
            let maxPrice = 0;
            for (let i = 0; i < this.detail.seats.length; i++) {
                const item = this.detail.seats[i];
                let tempMinPrice =
                    Math.round(number.operation(`${item.fastDrawModePrice}*${0.2}`) * 10) / 10;
                let tempMaxPrice =
                    Math.round(number.operation(`${item.fastDrawModePrice}*${0.8}`) * 10) / 10;
                minPrice = number.operation(`${minPrice}+${tempMinPrice}`);
                maxPrice = number.operation(`${maxPrice}+${tempMaxPrice}`);
            }
            return `${+minPrice}~${+maxPrice}`;
        },
    },
    watch: {
        showPopupStatus(val) {
            if (val) {
                this.$util.lockScreen();
            } else {
                this.$util.unlockScreen();
            }
        },
    },
    created() {
        this.id = this.$route.query.orderId;
        this.orderNo = this.$route.query.orderNo;
        this.ecm = JSON.parse(this.$route.query.ecm);
        this.efdm = JSON.parse(this.$route.query.efdm);
        this.eam = JSON.parse(this.$route.query.eam);
        this.getMovieInfo();
        this.getCanUseCoupon();
        this.getQMMprice();
    },
    methods: {
        getMovieInfo() {
            if (this.orderNo) {
                this.$util
                    .get(GET_ORDER_INFO_FOR_ORDER_NO, {
                        orderNo: this.orderNo,
                    })
                    .then(res => {
                        this.orderInfoResNext(res);
                    });
            } else if (this.id) {
                this.$util.get(`${GET_ORDER_INFO}/${this.id}`).then(res => {
                    this.orderInfoResNext(res);
                });
            }
        },
        getCanUseCoupon() {
            this.$util
                .post(GET_AVAILABLE_COUPON_LIST, {
                    orderNo: this.orderNo,
                })
                .then(res => {
                    if (res.success && res.data.length > 0) {
                        this.hasUseCoupon = true;
                    } else {
                        this.hasUseCoupon = false;
                    }
                });
        },
        orderInfoResNext(res) {
            if (res.success) {
                // 设置购票方式 start
                if (!this.ecm) {
                    this.status.preferential = false;
                } else {
                    this.status.preferential = true;
                }
                if (!this.efdm) {
                    this.status.directPurchase = false;
                } else {
                    this.status.directPurchase = true;
                }
                if (!this.eam) {
                    this.status.biddingPurchase = false;
                } else {
                    this.status.biddingPurchase = true;
                }

                // if (this.status.preferential && this.status.directPurchase) {
                //     this.chooseIndex = res.data.drawMode == 0 ? 0 : 1;
                // }
                // if (this.status.biddingPurchase && this.status.preferential) {
                //     this.chooseIndex = 2;
                // } else if (this.status.preferential) {
                //     this.chooseIndex = 0;
                // } else if (this.status.directPurchase) {
                //     this.chooseIndex = 1;
                // }

                if (res.data.drawMode == 0 && res.data.auction) {
                    this.chooseIndex = 2;
                } else if (res.data.drawMode == 0) {
                    this.chooseIndex = 0;
                } else if (res.data.drawMode == 5) {
                    this.chooseIndex = 1;
                }

                if (this.chooseIndex == 0) {
                    this.totalPrice = res.data.totalPrice;
                } else if (this.chooseIndex == 1) {
                    this.totalPrice = number.operation(
                        `${res.data.seatsCount}*${res.data.marketUnitPrice}`
                    );
                }
                // 设置购票方式 end
                // 凭借电影信息说明 start
                res.data.movieInformation =
                    moment(res.data.showTime).format('M月D日 HH:mm') + ' ' + res.data.versionTypes;
                // 凭借电影信息说明 end
                // 是否同意调座
                this.acceptAdjust = res.data.acceptAdjust;
                this.detail = res.data;
                this.userMobile = this.detail.userMobile;
                this.totalMarketPrice = +number.operation(
                    `${res.data.marketUnitPrice}*${res.data.seatsCount}`
                );
                this.saveAmount = this.detail.saveAmount;
            }
        },
        checkRead() {
            this.payAgree = !this.payAgree;
        },
        toGuide() {
            window.open(
                `${window.location.origin}/zhengce/zhengceku/2020-07/16/content_5527363.html`
            );
        },
        showTip() {
            this.showPopupStatus = true;
        },
        hideTip() {
            this.showPopupStatus = false;
        },
        hideDialog() {
            this.showAgreementStatus = false;
        },
        toSelectCoupon() {
            this.$util.pageJump(PAGE_COUPON_SELECT, {
                orderNo: this.orderNo,
                seatsCount: this.detail.seatsCount,
            });
        },
        // 切换是否接受调座位
        switchAcceptAdjust() {
            if (this.acceptAdjust) {
                this.acceptAdjustDialogStatus = true;
            } else {
                this.acceptAdjust = !this.acceptAdjust;
            }
        },
        // 切换模式
        async clickChoose(index, status) {
            if (!status && index == 0) {
                this.showEcmToast();
                return;
            } else if (!status) {
                return;
            }
            this.chooseIndex = index;
            let tempDrawMode = { 0: 0, 1: 5, 2: 0 }[index];
            await this.$util.post(UPDATE_ORDER_DRAW_MODE, {
                orderNo: this.detail.orderNo,
                drawMode: tempDrawMode,
            });
            this.getMovieInfo();
        },
        // 拉去趣满满价格
        getQMMprice() {
            this.$util
                .post(GET_QMM_PRICE, {
                    orderNo: this.orderNo,
                })
                .then(res => {
                    if (res.success) {
                        this.qmmPrice = res.data.settlePrice;
                        this.qzPrice = res.data.selfPrice;
                    }
                });
        },
        doubt() {
            this.$toast('底价折扣票数量有限，询价后价格满意请即时支付，否则将无法再次询价哦~');
        },
        showEcmToast() {
            if (this.detail.disableCompetitionModeType == 1 && this.stopSellMinuteOfSelfText) {
                this.$toast(
                    `特惠抢票，请最少提前${this.$store.state.common.config.stopSellMinuteOfSelfText}！！！`,
                    3000
                );
            } else if (this.detail.disableCompetitionModeType == 2) {
                this.$toast(
                    `特惠票已抢光，非精品影院每${this.detail.competitionModeReleaseInterval}分钟释放一批折扣票，建议选择精品影院购票。`,
                    3000
                );
            }
        },
        // 设置调座状态
        setAcceptAdjustStatus(status) {
            this.acceptAdjust = status;
            this.acceptAdjustDialogStatus = false;
        },
        submit() {
            // if (!this.payAgree) {
            //     this.showAgreementStatus = true;
            //     return;
            // }
            this.showAgreementStatus = false;
            if (!this.userMobile || this.userMobile.length != 11) {
                this.$toast('请填写正确的手机号');
                return;
            }
            let requestList = [];
            // 验证手机号 是否需要修改
            if (this.userMobile != this.detail.userMobile) {
                requestList.push(() =>
                    this.$util.post(UPDATE_ORDER_USER_MOBILE, {
                        orderNo: this.detail.orderNo,
                        userMobile: this.userMobile,
                    })
                );
            }
            // 验证是否调整同意调座
            if (this.acceptAdjust != this.detail.acceptAdjust) {
                requestList.push(() =>
                    this.$util.post(UPDATE_ORDER_ACCEPT_ADJUST, {
                        orderNo: this.detail.orderNo,
                        acceptAdjust: this.acceptAdjust,
                    })
                );
            }

            Promise.all(requestList.map(v => v())).then(([...promiseResList]) => {
                for (let i = 0; i < promiseResList.length; i++) {
                    const promiseResItem = promiseResList[i];
                    if (!promiseResItem.success) {
                        return;
                    }
                }
                if (this.chooseIndex == 2) {
                    this.submitBidOrder();
                } else {
                    this.payNext();
                }
            });
        },
        submitBidOrder() {
            this.$util.post(`${SUBMIT_BID_ORDER}?orderNo=${this.detail.orderNo}`).then(res => {
                if (res.success) {
                    this.$util.pageJump({
                        path: PAGE_ORDER_BID,
                        query: {
                            orderNo: this.detail.orderNo,
                        },
                        config: {
                            jumpType: 1,
                        },
                    });
                }
            });
        },
        payNext() {
            if (this.detail.totalPrice == 0) {
                this.$util
                    .post(SUBMIT_0_ORDER, {
                        orderNo: this.detail.orderNo,
                    })
                    .then(res => {
                        this.$util.pageJump(PAGE_ORDER_INFO, {
                            orderNo: this.detail.orderNo,
                        });
                    });
            } else {
                pay({
                    orderType: 5,
                    orderId: this.detail.id,
                    orderNo: this.detail.orderNo,
                }).then(payRes => {
                    if (payRes.success) {
                    } else {
                        this.$toast(payRes.message);
                    }
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
@footerHeight: .pxToRem(100) [];
.pay {
    width: 100%;
    min-height: 100vh;
    padding-bottom: calc(@footerHeight + .pxToRem(20) []);
    box-sizing: border-box;

    .order-info {
        background: white;
        margin: .pxToRem(20) [] .pxToRem(30) [] .pxToRem(0) [];
        border-radius: .pxToRem(40) [];
        .session-info {
            display: flex;
            padding: .pxToRem(40) [] .pxToRem(30) [] 0 .pxToRem(30) [];
            .order-item-img {
                width: .pxToRem(160) [];
                height: .pxToRem(210) [];
                border-radius: .pxToRem(16) [];
                overflow: hidden;
                .img {
                    width: 100%;
                    height: 100%;
                }
            }
            .order-item-content {
                flex: 1;
                margin-left: .pxToRem(30) [];
                .film-name {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(40) [];
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.9);
                    margin-bottom: .pxToRem(12) [];
                }
                .time,
                .cinema-name,
                .hall-name {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                .seat-list {
                    margin-top: .pxToRem(12) [];
                    .seat-item {
                        display: inline-block;
                        padding: .pxToRem(4) [] .pxToRem(12) [];
                        border: .pxToRem(1) [] solid #313131;
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        color: rgba(0, 0, 0, 0.9);
                        border-radius: .pxToRem(8) [];
                        margin-right: .pxToRem(8) [];
                        margin-bottom: .pxToRem(8) [];
                    }
                }
            }
        }
        .dividing-line {
            height: .pxToRem(40) [];
            .line-item {
                .base-center;
                width: .pxToRem(630) [];
                height: .pxToRem(1) [];
                background: rgba(0, 0, 0, 0.15);
            }
            &::before {
                content: ' ';
                .base-center-y;
                left: 0;
                height: .pxToRem(36) [];
                width: .pxToRem(18) [];
                background: #f5f5f5;
                border-top-right-radius: .pxToRem(18) [];
                border-bottom-right-radius: .pxToRem(18) [];
            }
            &::after {
                content: ' ';
                .base-center-y;
                right: 0;
                height: .pxToRem(36) [];
                width: .pxToRem(18) [];
                background: #f5f5f5;
                border-top-left-radius: .pxToRem(18) [];
                border-bottom-left-radius: .pxToRem(18) [];
            }
        }
        .tip-list {
            display: flex;
            padding: .pxToRem(0) [] .pxToRem(64) [] .pxToRem(14) [] .pxToRem(30) [];
            height: .pxToRem(76) [];
            line-height: .pxToRem(76) [];
            justify-content: space-between;
            align-items: center;
            .tip-item {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #d90209;
                font-size: .pxToRem(28) [];
                font-weight: bold;
                img {
                    .sq(32);
                }
                span {
                    margin-left: .pxToRem(10) [];
                }
                &:last-child {
                    color: rgba(0, 0, 0, 0.9);
                    font-weight: bold;
                }
            }
            &:before {
                content: ' ';
                position: absolute;
                top: .pxToRem(26) [];
                right: .pxToRem(30) [];
                .sq(24);
                background: url(~@/assets/icons/icon-right.png);
                background-size: cover;
            }
        }
    }

    .model {
        margin: .pxToRem(20) [] .pxToRem(30) [] .pxToRem(0) [];
        margin-top: .pxToRem(20) [];
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) [] rgba(0, 0, 0, 0.08);
        padding: .pxToRem(23) [] .pxToRem(30) [];
        border-radius: .pxToRem(30) [];
        background: white;
        .line {
            display: flex;
            justify-content: space-between;
            height: .pxToRem(54) [];
            line-height: .pxToRem(54) [];
            .line-title {
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.9);
                white-space: nowrap;
            }
            .line-value {
                display: flex;
                font-size: .pxToRem(30) [];
            }
            &.coupon {
                align-items: center;
                padding: .pxToRem(20) [] 0;
                .line-title {
                    flex: 1;
                }
                .coupon-info {
                    .no-coupon {
                        margin-right: .pxToRem(20) [];
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.5);
                        line-height: .pxToRem(44) [];
                    }
                    .has-coupon {
                        height: .pxToRem(44) [];
                        line-height: .pxToRem(44) [];
                        padding: 0 .pxToRem(30) [] 0 .pxToRem(70) [];
                        background: url('~@/assets/icons/icon-card-yellow.png') rgba(0, 0, 0, 0.9);
                        background-repeat: no-repeat;
                        background-size: .pxToRem(32) [] .pxToRem(32) [];
                        background-position: center left .pxToRem(30) [];
                        border-radius: .pxToRem(22) [];
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: #f8c32f;
                        line-height: .pxToRem(44) [];
                    }
                }
                .icon-right {
                    .sq(32);
                    background: url('~@/assets/icons/icon-right.png');
                    background-size: cover;
                }
            }
            &.price-box {
                padding: .pxToRem(30) [] 0;
                .line-title {
                    display: flex;
                    .original-price {
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.5);
                        margin-right: .pxToRem(14) [];
                        &.line-through {
                            text-decoration: line-through;
                        }
                    }
                    .save-amount {
                        font-size: .pxToRem(28) [];
                        font-weight: 600;
                        color: #f7b500;
                    }
                }
                .line-value {
                    .subtotal {
                        font-size: .pxToRem(28) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.5);
                    }
                    .amount {
                        font-size: .pxToRem(30) [];
                        font-weight: 600;
                        color: #d80108;
                    }
                }
                &::before {
                    content: ' ';
                    position: absolute;
                    top: 0;
                    left: .pxToRem(0) [];
                    right: .pxToRem(0) [];
                    height: .pxToRem(1) [];
                    border-radius: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.15);
                }
                &::after {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: .pxToRem(0) [];
                    right: .pxToRem(0) [];
                    height: .pxToRem(1) [];
                    border-radius: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.15);
                }
            }
            &.mobile {
                margin-top: .pxToRem(24) [];
                .line-value {
                    .input {
                        text-align: right;
                        background: rgba(0, 0, 0, 0);
                    }
                }
            }
            &.notice {
                .line-value {
                    align-items: center;
                    .section-img {
                        .sq(32);
                        margin-right: .pxToRem(16) [];
                    }
                }
            }
        }
        .mobile-tip {
            line-height: .pxToRem(44) [];
            font-size: .pxToRem(28) [];
            font-weight: 500;
            color: #d90209;
        }
        &.seat {
            padding: .pxToRem(30) [];
            .line {
                height: .pxToRem(44) [];
                line-height: .pxToRem(44) [];
                .line-title {
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                .line-value {
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.5);
                }
            }
            .accept-adjust-box {
                margin-top: .pxToRem(44) [];
                .accept-adjust-title {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(30) [];
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.9);
                }
                .accept-adjust-tip {
                    margin-top: .pxToRem(10) [];
                    line-height: .pxToRem(38) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                }
                .status {
                    position: absolute;
                    top: .pxToRem(-4) [];
                    right: 0;
                    width: .pxToRem(80) [];
                    height: .pxToRem(48) [];
                    border-radius: .pxToRem(36) [];
                    // background: @theme_color_first;
                    background: #f0f0f0;
                    box-sizing: border-box;

                    &::after {
                        content: ' ';
                        .base-center-y;
                        right: .pxToRem(34) [];
                        .sq(43);
                        background: white;
                        border-radius: 100%;
                        transition: all 0.3s;
                    }
                    &.accept-adjust {
                        background: @theme_color_first;
                        &::after {
                            right: .pxToRem(3) [];
                        }
                    }
                }
            }
        }
    }

    .ticket-type-box {
        margin-top: .pxToRem(20) [];
        margin-left: .pxToRem(30) [];
        margin-right: .pxToRem(30) [];
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
        border-radius: .pxToRem(40) [];
        background: white;
        .title {
            padding: .pxToRem(20) [] .pxToRem(30) [];
            font-size: .pxToRem(28) [];
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
            line-height: .pxToRem(40) [];
        }
        .ticket-type-item {
            padding: .pxToRem(25) [] .pxToRem(30) [];
            .status-img {
                position: absolute;
                top: .pxToRem(30) [];
                right: .pxToRem(22) [];
                width: .pxToRem(44) [];
                height: .pxToRem(44) [];
            }
            .tip-51 {
                margin-top: .pxToRem(20) [];
                margin-bottom: .pxToRem(-20) [];
                font-weight: bold;
                color: #d90209;
            }
            .tip {
                margin-top: .pxToRem(30) [];
                // padding-right: .pxToRem(60) [];
                .line {
                    display: block;
                    line-height: .pxToRem(36) [];
                    color: rgba(0, 0, 0, 0.5);
                    font-size: .pxToRem(24) [];
                    transition: all 0.3s;
                }
                &:not(.open) {
                    .line + .line {
                        display: none;
                    }
                }

                .more-show {
                    position: absolute;
                    top: 0;
                    right: 0;
                    .sq(32);
                    background: url('~@/assets/icons/icon-down-32x32.png');
                    background-size: contain;
                    transition: all 0.3s;
                }
                &.open {
                    .more-show {
                        transform: rotate(180deg);
                    }
                }
            }
            .line {
                .text {
                    font-weight: bold;
                    color: #d90209;
                }
                .name {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(30) [];
                    color: rgba(0, 0, 0, 0.9);
                    &.doubt {
                        &:before {
                            position: absolute;
                            right: .pxToRem(-48) [];
                            top: 50%;
                            transform: translateY(-50%);
                            content: ' ';
                            width: .pxToRem(32) [];
                            height: .pxToRem(32) [];
                            background: url('~@/assets/icons/icon-doubt.png');
                            background-size: contain;
                        }
                    }
                }
                .price {
                    margin-left: .pxToRem(36) [];
                    font-size: .pxToRem(22) [];
                    color: rgba(0, 0, 0, 0.3);
                    .text {
                        font-size: .pxToRem(36) [];
                        line-height: .pxToRem(36) [];
                        margin-right: .pxToRem(8) [];
                    }
                    .company {
                        line-height: .pxToRem(32) [];
                        font-size: .pxToRem(22) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .characteristic {
                    margin-top: .pxToRem(15) [];
                    margin-right: .pxToRem(10) [];
                    padding: 0 .pxToRem(16) [];
                    box-sizing: border-box;
                    height: .pxToRem(34) [];
                    line-height: .pxToRem(34) [];
                    border: .pxToRem(2) [] solid rgba(0, 0, 0, 1);
                    border-radius: .pxToRem(8) [];
                    font-size: .pxToRem(20) [];
                    &:nth-child(1) {
                        color: #f7b500;
                        border-color: #f7b500;
                    }
                    &:nth-child(2) {
                        color: #49c376;
                        border-color: #49c376;
                    }
                    &:nth-child(3) {
                        color: rgba(0, 0, 0, 0.9);
                        border-color: rgba(0, 0, 0, 0.9);
                    }
                }
            }
            > .line {
                display: flex;
                align-items: flex-end;
            }
            &.no-select {
                // -webkit-filter: grayscale(100%);
                // -moz-filter: grayscale(100%);
                // -ms-filter: grayscale(100%);
                // -o-filter: grayscale(100%);
                // filter: grayscale(100%);
                // filter: gray;
                * {
                    color: #c7c7c7 !important;
                    border-color: #c7c7c7 !important;
                }
            }
        }
        .ticket-type-item + .ticket-type-item {
            &::after {
                content: ' ';
                position: absolute;
                top: 0;
                left: .pxToRem(30) [];
                right: .pxToRem(30) [];
                height: .pxToRem(1) [];
                background: rgba(0, 0, 0, 0.15);
                border-radius: .pxToRem(1) [];
            }
        }
    }

    .accept-adjust-dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 101;
        .content {
            .base-center;
            width: .pxToRem(650) [];
            background: #ffffff;
            border-radius: .pxToRem(40) [];
            .header {
                background: url('~@/assets/icons/icon-dialog-title-bg.png');
                background-size: contain;
                width: .pxToRem(650) [];
                height: .pxToRem(135) [];
                &::before {
                    content: ' ';
                    position: absolute;
                    bottom: .pxToRem(-33) [];
                    left: .pxToRem(206) [];
                    width: .pxToRem(206) [];
                    height: .pxToRem(136) [];
                    background: url('~@/assets/icons/icon-dialog-title-logo.png');
                    background-size: contain;
                }
            }
            .message {
                margin-top: .pxToRem(100) [];
                p {
                    text-align: center;
                    padding: 0 .pxToRem(40) [];
                    line-height: .pxToRem(56) [];
                    font-size: .pxToRem(32) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                }
            }
            .btn-list {
                display: flex;
                justify-content: space-between;
                margin-top: .pxToRem(56) [];
                margin-bottom: .pxToRem(56) [];
                padding: 0 .pxToRem(50) [];
                .btn-item {
                    width: .pxToRem(260) [];
                    height: .pxToRem(104) [];
                    background: #ffffff;
                    border-radius: .pxToRem(52) [];
                    border: 1px solid #313131;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    p {
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.9);
                        text-align: center;
                    }
                    p:first-child {
                        line-height: .pxToRem(40) [];
                        font-size: .pxToRem(24) [];
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.9);
                        text-align: center;
                    }
                    &.agree {
                        background: @theme_color_first;
                        border: 1px solid @theme_color_first;
                    }
                }
            }
        }
    }
    .keynote {
        color: #d90209;
    }
    .secondary {
        color: rgba(0, 0, 0, 0.5);
    }
    .section-content {
        color: rgba(0, 0, 0, 0.6);
    }
    .link {
        color: #0091ff;
    }
    .popup {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: @footerHeight;
        background: rgba(0, 0, 0, 0.8);
        z-index: 99;
        .tip-message {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            border-top-left-radius: .pxToRem(40) [];
            border-top-right-radius: .pxToRem(40) [];
            .title {
                height: .pxToRem(106) [];
                line-height: .pxToRem(106) [];
                text-align: center;
                font-size: .pxToRem(32) [];
                font-weight: bold;
                color: rgba(0, 0, 0, 0.9);
                &:after {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: .pxToRem(50) [];
                    right: .pxToRem(50) [];
                    height: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.1);
                }
            }
            .content {
                padding: 0 .pxToRem(50) [];
                padding-bottom: .pxToRem(50) [];
                .bold {
                    margin-top: .pxToRem(30) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                p {
                    margin-top: .pxToRem(10) [];
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.5);
                    line-height: .pxToRem(44) [];
                }
            }
            .close {
                position: absolute;
                top: .pxToRem(37) [];
                right: .pxToRem(50) [];
                .sq(32);
            }
        }
    }
    .dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 101;
        .dialog-agreement {
            .base-center;
            width: .pxToRem(650) [];
            background: white;
            border-radius: .pxToRem(40) [];
            .title {
                margin-top: .pxToRem(30) [];
                line-height: .pxToRem(80) [];
                color: #333333;
                font-weight: bold;
                font-size: .pxToRem(32) [];
                text-align: center;
            }
            .content {
                padding: 0 .pxToRem(30) [];
                font-size: .pxToRem(28) [];
                margin-top: .pxToRem(60) [];
                p {
                    line-height: .pxToRem(48) [];
                    padding-left: .pxToRem(40) [];
                    margin-top: .pxToRem(20) [];
                    margin-bottom: .pxToRem(10) [];
                    color: #000000;
                    .keynote {
                        font-size: .pxToRem(32) [];
                        color: #d90209;
                        font-weight: bold;
                    }
                    &.no-1 {
                        &:before {
                            content: '1、';
                            position: absolute;
                            left: 0;
                        }
                    }
                    &.no-2 {
                        &:before {
                            content: '2、';
                            position: absolute;
                            left: 0;
                        }
                    }
                    &.no-3 {
                        &:before {
                            content: '3、';
                            position: absolute;
                            left: 0;
                        }
                    }
                }
                .line-agree {
                    margin-top: .pxToRem(40) [];
                    margin-bottom: .pxToRem(10) [];
                    text-align: center;
                    color: #666666;
                    .value {
                        padding-left: .pxToRem(40) [];
                        display: inline-block;
                        background: url('~@/assets/icons/icon-unchoose.32.png');
                        background-size: .pxToRem(32) [] .pxToRem(32) [];
                        background-repeat: no-repeat;
                        background-position: left center;
                    }
                    &.ok {
                        .value {
                            background: url('~@/assets/icons/icon-choose.32.png');
                            background-size: .pxToRem(32) [] .pxToRem(32) [];
                            background-repeat: no-repeat;
                            background-position: left center;
                        }
                    }
                }
                .btn {
                    text-align: center;
                    margin: 0 auto;
                    line-height: .pxToRem(80) [];
                    &.btn-agree {
                        width: .pxToRem(560) [];
                        margin-top: .pxToRem(40) [];
                        margin-bottom: .pxToRem(50) [];
                        background: @theme_color_first;
                        border-radius: .pxToRem(40) [];
                        opacity: 0.6;
                        color: #333333;
                        &.ok {
                            opacity: 1;
                        }
                    }
                    &.btn-no {
                        .base-center-x;
                        bottom: .pxToRem(-150) [];
                        color: white;
                    }
                }
            }
            &:before {
                content: ' ';
                position: absolute;
                top: 0;
                background: url('~@/assets/icons/icon-dialog-title-bg.png');
                background-size: contain;
                width: .pxToRem(650) [];
                height: .pxToRem(135) [];
            }
        }
    }
    .footer {
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
        position: fixed;
        bottom: 0;
        font-size: .pxToRem(30) [];
        z-index: 100;
        .box {
            width: 100%;
            height: @footerHeight;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .money {
            font-size: .pxToRem(36) [];
            color: #d90209;
            font-weight: bold;
        }
        .btn {
            padding: .pxToRem(30) [] .pxToRem(65) [];
            background: @theme_color_first;
            border-radius: .pxToRem(80) [];
            font-size: .pxToRem(30) [];
            line-height: .pxToRem(17) [];
            border: none;
        }
        .btn::after {
            border: none;
            content: '';
        }
    }
    .footer-occupy {
        width: 100%;
    }
    .filme-another {
        display: flex;
        justify-content: flex-end;
        margin-top: .pxToRem(10) [];
    }
    .filme-commission {
        font-size: .pxToRem(22) [];
        color: #000000;
        margin-right: .pxToRem(10) [];
        &-num {
            font-size: .pxToRem(24) [];
            color: #ff1e1e;
        }
    }
}
</style>
